export type LanguageSelectorKeyResult = {
  handled: boolean;
  open?: boolean;
  activeIndex?: number;
  focusTrigger?: boolean;
  activate?: boolean;
};

export function resolveLanguageSelectorKey({
  key,
  source,
  isOpen,
  activeIndex,
  selectedIndex,
  optionCount,
}: {
  key: string;
  source: "trigger" | "option";
  isOpen: boolean;
  activeIndex: number;
  selectedIndex: number;
  optionCount: number;
}): LanguageSelectorKeyResult {
  if (key === "Escape" && isOpen) {
    return { handled: true, open: false, focusTrigger: true };
  }

  if (source === "trigger" && (key === "ArrowDown" || key === "ArrowUp")) {
    return {
      handled: true,
      open: true,
      activeIndex: key === "ArrowUp" ? optionCount - 1 : selectedIndex,
    };
  }

  if (source === "option" && (key === "ArrowDown" || key === "ArrowUp")) {
    const offset = key === "ArrowDown" ? 1 : -1;
    return {
      handled: true,
      activeIndex: (activeIndex + offset + optionCount) % optionCount,
    };
  }

  if (source === "option" && (key === "Home" || key === "End")) {
    return {
      handled: true,
      activeIndex: key === "Home" ? 0 : optionCount - 1,
    };
  }

  if (source === "option" && (key === "Enter" || key === " ")) {
    return { handled: true, activate: true };
  }

  return { handled: false };
}
